(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vyne-pdp-black"]) return;
  try {
    
(function(){
  var wrap = document.querySelector('.vyne-bpd-wrap');
  if (!wrap) return;

  var shots = wrap.querySelectorAll('.vyne-bpd-stage .vyne-bpd-shot');
  var thumbs = wrap.querySelectorAll('.vyne-bpd-thumbs .t');
  function showShot(i){
    shots.forEach(function(s){ s.classList.toggle('on', +s.dataset.i === i); });
    thumbs.forEach(function(t){ t.classList.toggle('on', +t.dataset.i === i); });
  }
  // The photos change only when the shopper taps a thumb or swipes (swipe: assets/vyne.js).
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ showShot(+t.dataset.i); }); });

  var modelName = wrap.querySelector('[data-model-name]');
  var modelSub = wrap.querySelector('[data-model-sub]');
  var variantInput = wrap.querySelector('[data-variant-id]');
  var modelPick = wrap.querySelector('[data-modelpick]');
  var modelTrigger = wrap.querySelector('[data-mp-trigger]');
  var curModel = modelName ? modelName.textContent.trim() : '';
  function closeModels(){ if (modelPick) modelPick.classList.remove('open'); if (modelTrigger) modelTrigger.setAttribute('aria-expanded', 'false'); }
  if (modelTrigger && modelPick) {
    modelTrigger.addEventListener('click', function(e){ e.stopPropagation(); var open = modelPick.classList.toggle('open'); modelTrigger.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.addEventListener('click', function(e){ if (!modelPick.contains(e.target)) closeModels(); });
  }
  wrap.querySelectorAll('.vyne-bpd-models .m').forEach(function(m){
    m.addEventListener('click', function(){
      wrap.querySelectorAll('.vyne-bpd-models .m').forEach(function(x){ x.classList.remove('on'); });
      m.classList.add('on');
      curModel = m.dataset.name || '';
      if (modelName) modelName.textContent = curModel;
      if (modelSub) modelSub.textContent = m.dataset.sub || '';
      var mp = wrap.querySelector('[data-model-prop]'); if (mp) mp.value = curModel;
      if (m.dataset.variant && variantInput) variantInput.value = m.dataset.variant;
      closeModels();
      syncSticky();
    });
  });

  var qtyInput = wrap.querySelector('[data-qty-input]');
  function setQty(n){
    n = Math.max(1, Math.min(9, n));
    if (qtyInput) qtyInput.value = n;
    var unit = parseFloat((wrap.querySelector('.vyne-bpd-buy .price .now').textContent || '0').replace(/[^0-9.]/g,'')) || 0;
    var total = unit * n;
    var p = wrap.querySelector('[data-add-price]');
    if (p) p.textContent = '— $' + total;
    syncSticky();
  }
  var plus = wrap.querySelector('[data-qty-plus]');
  var minus = wrap.querySelector('[data-qty-minus]');
  if (plus)  plus.addEventListener('click', function(){ setQty(parseInt(qtyInput.value || '1', 10) + 1); });
  if (minus) minus.addEventListener('click', function(){ setQty(parseInt(qtyInput.value || '1', 10) - 1); });
  if (qtyInput) qtyInput.addEventListener('change', function(){ setQty(parseInt(qtyInput.value || '1', 10)); });

  var sticky = wrap.querySelector('[data-stickybar]');
  var stickySub = wrap.querySelector('[data-sticky-sub]');
  var stickyPrice = wrap.querySelector('[data-sticky-price]');
  function syncSticky(){
    if (stickySub) stickySub.textContent = (curModel ? curModel + ' · ' : '') + 'Qty ' + (qtyInput ? qtyInput.value : '1');
    var unit = parseFloat((wrap.querySelector('.vyne-bpd-buy .price .now').textContent || '0').replace(/[^0-9.]/g,'')) || 0;
    var n = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
    if (stickyPrice) stickyPrice.textContent = '$' + (unit * n);
  }
  var actions = wrap.querySelector('[data-actions]');
  if (actions && sticky && 'IntersectionObserver' in window) {
    var io2 = new IntersectionObserver(function(entries){
      var e = entries[0];
      sticky.classList.toggle('show', !e.isIntersecting && window.scrollY > 400);
    }, { rootMargin: '-80px 0px 0px 0px' });
    io2.observe(actions);
  }

  var stickyAdd = wrap.querySelector('[data-sticky-add]');
  if (stickyAdd) stickyAdd.addEventListener('click', function(){
    var form = wrap.querySelector('[data-add-form]');
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });

  var addBtn = wrap.querySelector('[data-add-btn]');
  if (addBtn) addBtn.addEventListener('click', function(){
    var orig = addBtn.innerHTML;
    setTimeout(function(){
      addBtn.innerHTML = '✓ Added to Bag';
      setTimeout(function(){ addBtn.innerHTML = orig; }, 1500);
    }, 50);
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    wrap.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    wrap.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  syncSticky();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyne-pdp-camera"]) return;
  try {
    
(function(){
  var wrap = document.querySelector('.vyne-kpd-wrap');
  if (!wrap) return;

  function fmt(cents){ return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  /* ---- gallery ---- */
  var shots = [].slice.call(wrap.querySelectorAll('.vyne-kpd-stage .vyne-kpd-shot'));
  var thumbs = [].slice.call(wrap.querySelectorAll('.vyne-kpd-thumbs .t'));
  var gi = 0;
  shots.forEach(function(s){ if (s.classList.contains('on')) gi = +s.dataset.i; });
  function showShot(i){
    gi = i;
    shots.forEach(function(s){ s.classList.toggle('on', +s.dataset.i === i); });
    thumbs.forEach(function(t){ t.classList.toggle('on', +t.dataset.i === i); });
    var t = thumbs[i], row = t && t.parentNode;
    if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: Math.max(0, t.offsetLeft - row.offsetLeft - 8), behavior: 'smooth' });
  }
  function shotFor(imageId){
    for (var k = 0; k < shots.length; k++) if (imageId && shots[k].dataset.image === imageId) return +shots[k].dataset.i;
    return -1;
  }

  /* ---- variants ---- */
  var variants = [];
  var vjson = wrap.querySelector('[data-variants]');
  if (vjson) { try { variants = JSON.parse(vjson.textContent); } catch(e){} }
  var modelBtns = [].slice.call(wrap.querySelectorAll('.vyne-kpd-models.static [data-model]'));
  var colorBtns = [].slice.call(wrap.querySelectorAll('.vyne-kpd-colors [data-color]'));
  var quickBtns = [].slice.call(wrap.querySelectorAll('.vyne-kpd-quick [data-qmodel]'));
  var quickCur = wrap.querySelector('[data-q-cur]');
  var quickCount = wrap.querySelector('[data-q-count]');
  var hasColor = colorBtns.length > 0;
  var cur = { model: '', color: '' };
  modelBtns.forEach(function(b){ if (b.classList.contains('on')) cur.model = b.dataset.model; });
  colorBtns.forEach(function(b){ if (b.classList.contains('on')) cur.color = b.dataset.color; });
  function variantFor(model, color){
    for (var i = 0; i < variants.length; i++){
      var v = variants[i];
      if (v.option1 === model && (!hasColor || v.option2 === color)) return v;
    }
    return null;
  }
  // A variant with no photo of its own shows any photo of the same model.
  function imageFor(v){
    if (v.featured_image) return String(v.featured_image.id);
    for (var i = 0; i < variants.length; i++) if (variants[i].option1 === v.option1 && variants[i].featured_image) return String(variants[i].featured_image.id);
    return '';
  }

  // The photos change only when the shopper taps a thumb or swipes (swipe: assets/vyne.js);
  // with real variants they also follow the model picker.
  // A thumb that is a colour of the current model picks that colour, so the
  // swatches and the photo never disagree.
  thumbs.forEach(function(t){ t.addEventListener('click', function(){
    var shot = shots[+t.dataset.i], img = shot && shot.dataset.image;
    if (hasColor && img){
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        if (v.option1 === cur.model && v.featured_image && String(v.featured_image.id) === img){ pickColor(v.option2); return; }
      }
    }
    showShot(+t.dataset.i);
  }); });
  // Thumbs tagged with models only show for the model that is picked.
  function filterThumbs(){
    var key = '|' + cur.model + '|';
    thumbs.forEach(function(t){ if (t.dataset.models) t.hidden = t.dataset.models.indexOf(key) < 0; });
  }

  /* ---- buy panel ---- */
  var form = wrap.querySelector('[data-add-form]');
  var variantInput = wrap.querySelector('[data-variant-id]');
  var qtyInput = wrap.querySelector('[data-qty-input]');
  var priceNow = wrap.querySelector('[data-price-now]');
  var addBtn = wrap.querySelector('[data-add-btn]');
  var addLabel = wrap.querySelector('[data-add-label]');
  var addPrice = wrap.querySelector('[data-add-price]');
  var modelLabel = wrap.querySelector('[data-model-label]');
  var colorLabel = wrap.querySelector('[data-color-label]');
  var sticky = wrap.querySelector('[data-stickybar]');
  var stickySub = wrap.querySelector('[data-sticky-sub]');
  var stickyPrice = wrap.querySelector('[data-sticky-price]');
  var stickyAdd = wrap.querySelector('[data-sticky-add]');
  var stickyImg = wrap.querySelector('[data-sticky-img]');
  var unitCents = parseInt(form && form.getAttribute('data-price'), 10) || 0;
  var soldOut = !!(addBtn && addBtn.disabled);
  var curModel = modelBtns.length ? cur.model + (hasColor && cur.color ? ' · ' + cur.color : '') : '';

  function qty(){ return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1; }
  function syncTotals(){
    var n = qty();
    if (addPrice) addPrice.textContent = '— ' + fmt(unitCents * n);
    if (stickyPrice) stickyPrice.textContent = fmt(unitCents * n);
    if (stickySub) stickySub.textContent = (curModel ? curModel + ' · ' : '') + 'Qty ' + n;
  }
  function setSoldOut(out){
    soldOut = out;
    if (addBtn) addBtn.disabled = out;
    if (addLabel) addLabel.textContent = out ? 'Sold out' : 'Add to Cart';
    if (addPrice) addPrice.hidden = out;
    if (stickyAdd){ stickyAdd.disabled = out; stickyAdd.textContent = out ? 'Sold out' : 'Add to Cart'; }
  }

  function applyVariant(v){
    modelBtns.forEach(function(b){ var on = b.dataset.model === cur.model; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    colorBtns.forEach(function(b){ var on = b.dataset.color === cur.color; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    filterThumbs();
    quickBtns.forEach(function(b){
      var on = b.dataset.qmodel === cur.model;
      b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on && b.parentNode.scrollWidth > b.parentNode.clientWidth) b.parentNode.scrollTo({ left: Math.max(0, b.offsetLeft - b.parentNode.offsetLeft - 18), behavior: 'smooth' });
    });
    if (quickCur) quickCur.textContent = cur.model + (hasColor && cur.color ? ' · ' + cur.color : '');
    if (quickCount){
      var n = 0;
      variants.forEach(function(x){ if (x.option1 === cur.model) n++; });
      quickCount.textContent = n + (n === 1 ? ' color' : ' colors');
    }
    if (modelLabel) modelLabel.textContent = cur.model;
    if (colorLabel) colorLabel.textContent = cur.color;
    curModel = cur.model + (hasColor && cur.color ? ' · ' + cur.color : '');
    if (variantInput) variantInput.value = v.id;
    unitCents = v.price;
    if (priceNow) priceNow.textContent = fmt(unitCents);
    setSoldOut(!v.available);
    var i = shotFor(imageFor(v));
    if (i >= 0){
      showShot(i);
      var ti = thumbs[i] && thumbs[i].querySelector('img');
      if (stickyImg && ti) stickyImg.src = ti.src;
    }
    if (window.history && history.replaceState){
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u.toString());
    }
    syncTotals();
  }
  // Picking a model shows only the colours that model comes in, keeping the
  // current colour when the new model has it too.
  function pickModel(model){
    cur.model = model;
    if (hasColor){
      var keep = false, firstAvail = '', firstAny = '';
      colorBtns.forEach(function(b){
        var v = variantFor(model, b.dataset.color);
        b.hidden = !v;
        b.classList.toggle('out', !!v && !v.available);
        if (!v) return;
        if (!firstAny) firstAny = b.dataset.color;
        if (v.available && !firstAvail) firstAvail = b.dataset.color;
        if (b.dataset.color === cur.color) keep = true;
      });
      if (!keep) cur.color = firstAvail || firstAny;
    }
    var v = variantFor(cur.model, cur.color);
    if (v) applyVariant(v);
  }
  function pickColor(color){
    cur.color = color;
    var v = variantFor(cur.model, cur.color);
    if (v) applyVariant(v);
  }
  modelBtns.forEach(function(b){ b.addEventListener('click', function(){ pickModel(b.dataset.model); }); });
  quickBtns.forEach(function(b){
    b.addEventListener('click', function(){ pickModel(b.dataset.qmodel); });
    // A link straight to a later model opens with its chip scrolled into view.
    if (b.classList.contains('on')) b.parentNode.scrollLeft = Math.max(0, b.offsetLeft - b.parentNode.offsetLeft - 18);
  });
  colorBtns.forEach(function(b){ b.addEventListener('click', function(){ pickColor(b.dataset.color); }); });

  // Single-variant fallback: a fixed model list sent as a line-item property.
  var modelPick = wrap.querySelector('[data-modelpick]');
  if (modelPick){
    var modelTrigger = wrap.querySelector('[data-mp-trigger]');
    var modelName = wrap.querySelector('[data-model-name]');
    var modelSub = wrap.querySelector('[data-model-sub]');
    if (modelName) curModel = modelName.textContent.trim();
    var closeModels = function(){ modelPick.classList.remove('open'); if (modelTrigger) modelTrigger.setAttribute('aria-expanded', 'false'); };
    if (modelTrigger){
      modelTrigger.addEventListener('click', function(e){ e.stopPropagation(); var open = modelPick.classList.toggle('open'); modelTrigger.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.addEventListener('click', function(e){ if (!modelPick.contains(e.target)) closeModels(); });
    }
    modelPick.querySelectorAll('.vyne-kpd-models .m').forEach(function(m){
      m.addEventListener('click', function(){
        modelPick.querySelectorAll('.vyne-kpd-models .m').forEach(function(x){ x.classList.remove('on'); });
        m.classList.add('on');
        curModel = m.dataset.name || '';
        if (modelName) modelName.textContent = curModel;
        if (modelSub) modelSub.textContent = m.dataset.sub || '';
        var mp = wrap.querySelector('[data-model-prop]'); if (mp) mp.value = curModel;
        closeModels();
        syncTotals();
      });
    });
  }

  /* ---- quantity ---- */
  function setQty(n){
    if (qtyInput) qtyInput.value = Math.max(1, Math.min(9, n || 1));
    syncTotals();
  }
  var plus = wrap.querySelector('[data-qty-plus]');
  var minus = wrap.querySelector('[data-qty-minus]');
  if (plus)  plus.addEventListener('click', function(){ setQty(qty() + 1); });
  if (minus) minus.addEventListener('click', function(){ setQty(qty() - 1); });
  if (qtyInput) qtyInput.addEventListener('change', function(){ setQty(parseInt(qtyInput.value, 10)); });

  /* ---- sticky bar ---- */
  var actions = wrap.querySelector('[data-actions]');
  if (actions && sticky && 'IntersectionObserver' in window) {
    var io2 = new IntersectionObserver(function(entries){
      var e = entries[0];
      sticky.classList.toggle('show', !e.isIntersecting && window.scrollY > 400);
    }, { rootMargin: '-80px 0px 0px 0px' });
    io2.observe(actions);
  }
  if (stickyAdd) stickyAdd.addEventListener('click', function(){
    if (soldOut || !form) return;
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  });

  if (addBtn) addBtn.addEventListener('click', function(){
    if (soldOut) return;
    setTimeout(function(){
      if (addLabel) addLabel.textContent = '✓ Added to Bag';
      if (addPrice) addPrice.hidden = true;
      setTimeout(function(){ setSoldOut(soldOut); }, 1500);
    }, 50);
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    wrap.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    wrap.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  syncTotals();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyne-pdp-color"]) return;
  try {
    
(function(){
  var wrap = document.querySelector('.vyne-cpd-wrap');
  if (!wrap) return;

  var shots = wrap.querySelectorAll('.vyne-cpd-stage .vyne-cpd-shot');
  var thumbs = wrap.querySelectorAll('.vyne-cpd-thumbs .t');
  function showShot(i){
    shots.forEach(function(s){ s.classList.toggle('on', +s.dataset.i === i); });
    thumbs.forEach(function(t){ t.classList.toggle('on', +t.dataset.i === i); });
  }
  // The photos change only when the shopper taps a thumb or swipes (swipe: assets/vyne.js).
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ showShot(+t.dataset.i); }); });

  var modelName = wrap.querySelector('[data-model-name]');
  var modelSub = wrap.querySelector('[data-model-sub]');
  var pick = wrap.querySelector('[data-modelpick]');
  var trig = wrap.querySelector('[data-mp-trigger]');
  var curModel = modelName ? modelName.textContent.trim() : '';
  function closeModels(){ if (pick) pick.classList.remove('open'); if (trig) trig.setAttribute('aria-expanded','false'); }
  if (trig && pick) {
    trig.addEventListener('click', function(e){ e.stopPropagation(); var o = pick.classList.toggle('open'); trig.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    document.addEventListener('click', function(e){ if (!pick.contains(e.target)) closeModels(); });
  }
  wrap.querySelectorAll('.vyne-cpd-models .m').forEach(function(m){
    m.addEventListener('click', function(){
      wrap.querySelectorAll('.vyne-cpd-models .m').forEach(function(x){ x.classList.remove('on'); });
      m.classList.add('on');
      curModel = m.dataset.name || '';
      if (modelName) modelName.textContent = curModel;
      if (modelSub) modelSub.textContent = m.dataset.sub || '';
      var mp = wrap.querySelector('[data-model-prop]'); if (mp) mp.value = curModel;
      closeModels(); syncSticky();
    });
  });

  var qtyInput = wrap.querySelector('[data-qty-input]');
  function unitCents(){ return parseFloat((wrap.querySelector('.vyne-cpd-buy .price .now').textContent||'0').replace(/[^0-9.]/g,'')) || 0; }
  function setQty(n){
    n = Math.max(1, Math.min(9, n));
    if (qtyInput) qtyInput.value = n;
    var p = wrap.querySelector('[data-add-price]');
    if (p) p.textContent = '— $' + (unitCents() * n);
    syncSticky();
  }
  var plus = wrap.querySelector('[data-qty-plus]');
  var minus = wrap.querySelector('[data-qty-minus]');
  if (plus) plus.addEventListener('click', function(){ setQty(parseInt(qtyInput.value||'1',10) + 1); });
  if (minus) minus.addEventListener('click', function(){ setQty(parseInt(qtyInput.value||'1',10) - 1); });
  if (qtyInput) qtyInput.addEventListener('change', function(){ setQty(parseInt(qtyInput.value||'1',10)); });

  var sticky = wrap.querySelector('[data-stickybar]');
  var stickySub = wrap.querySelector('[data-sticky-sub]');
  var stickyPrice = wrap.querySelector('[data-sticky-price]');
  function syncSticky(){
    if (stickySub) stickySub.textContent = (curModel ? curModel + ' · ' : '') + 'Qty ' + (qtyInput ? qtyInput.value : '1');
    var n = qtyInput ? parseInt(qtyInput.value||'1',10) : 1;
    if (stickyPrice) stickyPrice.textContent = '$' + (unitCents() * n);
  }
  var actions = wrap.querySelector('[data-actions]');
  if (actions && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(en){
      sticky.classList.toggle('show', !en[0].isIntersecting && window.scrollY > 400);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(actions);
  }
  var sAdd = wrap.querySelector('[data-sticky-add]');
  if (sAdd) sAdd.addEventListener('click', function(){
    var f = wrap.querySelector('[data-add-form]');
    if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
  });

  var addBtn = wrap.querySelector('[data-add-btn]');
  if (addBtn) addBtn.addEventListener('click', function(){
    var orig = addBtn.innerHTML;
    setTimeout(function(){
      addBtn.innerHTML = '✓ Added to Bag';
      setTimeout(function(){ addBtn.innerHTML = orig; }, 1500);
    }, 50);
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(en){
      en.forEach(function(e){ if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    wrap.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    wrap.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  syncSticky();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyne-pdp-dune"]) return;
  try {
    
(function(){
  var wrap = document.querySelector('.vyne-dpd-wrap');
  if (!wrap) return;

  var shots = wrap.querySelectorAll('.vyne-dpd-stage .vyne-dpd-shot');
  var thumbs = wrap.querySelectorAll('.vyne-dpd-thumbs .t');
  function showShot(i){
    shots.forEach(function(s){ s.classList.toggle('on', +s.dataset.i === i); });
    thumbs.forEach(function(t){ t.classList.toggle('on', +t.dataset.i === i); });
  }
  // The photos change only when the shopper taps a thumb or swipes (swipe: assets/vyne.js).
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ showShot(+t.dataset.i); }); });

  var modelName = wrap.querySelector('[data-model-name]');
  var modelSub = wrap.querySelector('[data-model-sub]');
  var variantInput = wrap.querySelector('[data-variant-id]');
  var modelPick = wrap.querySelector('[data-modelpick]');
  var modelTrigger = wrap.querySelector('[data-mp-trigger]');
  var curModel = modelName ? modelName.textContent.trim() : '';
  function closeModels(){ if (modelPick) modelPick.classList.remove('open'); if (modelTrigger) modelTrigger.setAttribute('aria-expanded', 'false'); }
  if (modelTrigger && modelPick) {
    modelTrigger.addEventListener('click', function(e){ e.stopPropagation(); var open = modelPick.classList.toggle('open'); modelTrigger.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.addEventListener('click', function(e){ if (!modelPick.contains(e.target)) closeModels(); });
  }
  wrap.querySelectorAll('.vyne-dpd-models .m').forEach(function(m){
    m.addEventListener('click', function(){
      wrap.querySelectorAll('.vyne-dpd-models .m').forEach(function(x){ x.classList.remove('on'); });
      m.classList.add('on');
      curModel = m.dataset.name || '';
      if (modelName) modelName.textContent = curModel;
      if (modelSub) modelSub.textContent = m.dataset.sub || '';
      var mp = wrap.querySelector('[data-model-prop]'); if (mp) mp.value = curModel;
      if (m.dataset.variant && variantInput) variantInput.value = m.dataset.variant;
      closeModels();
      syncSticky();
    });
  });

  var qtyInput = wrap.querySelector('[data-qty-input]');
  function setQty(n){
    n = Math.max(1, Math.min(9, n));
    if (qtyInput) qtyInput.value = n;
    var unit = parseFloat((wrap.querySelector('.vyne-dpd-buy .price .now').textContent || '0').replace(/[^0-9.]/g,'')) || 0;
    var total = unit * n;
    var p = wrap.querySelector('[data-add-price]');
    if (p) p.textContent = '— $' + total;
    syncSticky();
  }
  var plus = wrap.querySelector('[data-qty-plus]');
  var minus = wrap.querySelector('[data-qty-minus]');
  if (plus)  plus.addEventListener('click', function(){ setQty(parseInt(qtyInput.value || '1', 10) + 1); });
  if (minus) minus.addEventListener('click', function(){ setQty(parseInt(qtyInput.value || '1', 10) - 1); });
  if (qtyInput) qtyInput.addEventListener('change', function(){ setQty(parseInt(qtyInput.value || '1', 10)); });

  var sticky = wrap.querySelector('[data-stickybar]');
  var stickySub = wrap.querySelector('[data-sticky-sub]');
  var stickyPrice = wrap.querySelector('[data-sticky-price]');
  function syncSticky(){
    if (stickySub) stickySub.textContent = (curModel ? curModel + ' · ' : '') + 'Qty ' + (qtyInput ? qtyInput.value : '1');
    var unit = parseFloat((wrap.querySelector('.vyne-dpd-buy .price .now').textContent || '0').replace(/[^0-9.]/g,'')) || 0;
    var n = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
    if (stickyPrice) stickyPrice.textContent = '$' + (unit * n);
  }
  var actions = wrap.querySelector('[data-actions]');
  if (actions && sticky && 'IntersectionObserver' in window) {
    var io2 = new IntersectionObserver(function(entries){
      var e = entries[0];
      sticky.classList.toggle('show', !e.isIntersecting && window.scrollY > 400);
    }, { rootMargin: '-80px 0px 0px 0px' });
    io2.observe(actions);
  }

  var stickyAdd = wrap.querySelector('[data-sticky-add]');
  if (stickyAdd) stickyAdd.addEventListener('click', function(){
    var form = wrap.querySelector('[data-add-form]');
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });

  var addBtn = wrap.querySelector('[data-add-btn]');
  if (addBtn) addBtn.addEventListener('click', function(){
    var orig = addBtn.innerHTML;
    setTimeout(function(){
      addBtn.innerHTML = '✓ Added to Bag';
      setTimeout(function(){ addBtn.innerHTML = orig; }, 1500);
    }, 50);
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    wrap.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    wrap.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  syncSticky();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyne-pdp-duo"]) return;
  try {
    
(function(){
  var wrap = document.querySelector('.vyne-fpd-wrap');
  if (!wrap) return;

  var shots = wrap.querySelectorAll('.vyne-fpd-stage .vyne-fpd-shot');
  var thumbs = wrap.querySelectorAll('.vyne-fpd-thumbs .t');
  function showShot(i){
    shots.forEach(function(s){ s.classList.toggle('on', +s.dataset.i === i); });
    thumbs.forEach(function(t){ t.classList.toggle('on', +t.dataset.i === i); });
  }
  // The photos change only when the shopper taps a thumb or swipes (swipe: assets/vyne.js).
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ showShot(+t.dataset.i); }); });

  var modelName = wrap.querySelector('[data-model-name]');
  var modelSub = wrap.querySelector('[data-model-sub]');
  var variantInput = wrap.querySelector('[data-variant-id]');

  // Colour picker: sets the variant, swaps the gallery to that colour's photos.
  var colorBtns = wrap.querySelectorAll('[data-colors] .c');
  var colorName = wrap.querySelector('[data-color-name]');
  colorBtns.forEach(function(b){
    b.addEventListener('click', function(){
      if (b.disabled) return;
      colorBtns.forEach(function(x){ x.classList.toggle('on', x === b); });
      var c = b.dataset.color;
      if (colorName) colorName.textContent = c;
      if (variantInput) variantInput.value = b.dataset.variant;
      wrap.querySelectorAll('.vyne-fpd-grp').forEach(function(g){ g.hidden = g.dataset.color !== c; });
      showShot(0);
      var first = wrap.querySelector('.vyne-fpd-grp[data-color="' + c + '"] .vyne-fpd-shot img'), stickyImg = wrap.querySelector('[data-sticky-img]');
      if (first && stickyImg) stickyImg.src = first.currentSrc || first.src;
      try { history.replaceState(null, '', location.pathname + '?variant=' + b.dataset.variant); } catch(e){}
    });
  });
  var modelPick = wrap.querySelector('[data-modelpick]');
  var modelTrigger = wrap.querySelector('[data-mp-trigger]');
  var curModel = modelName ? modelName.textContent.trim() : '';
  function closeModels(){ if (modelPick) modelPick.classList.remove('open'); if (modelTrigger) modelTrigger.setAttribute('aria-expanded', 'false'); }
  if (modelTrigger && modelPick) {
    modelTrigger.addEventListener('click', function(e){ e.stopPropagation(); var open = modelPick.classList.toggle('open'); modelTrigger.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.addEventListener('click', function(e){ if (!modelPick.contains(e.target)) closeModels(); });
  }
  wrap.querySelectorAll('.vyne-fpd-models .m').forEach(function(m){
    m.addEventListener('click', function(){
      wrap.querySelectorAll('.vyne-fpd-models .m').forEach(function(x){ x.classList.remove('on'); });
      m.classList.add('on');
      curModel = m.dataset.name || '';
      if (modelName) modelName.textContent = curModel;
      if (modelSub) modelSub.textContent = m.dataset.sub || '';
      var mp = wrap.querySelector('[data-model-prop]'); if (mp) mp.value = curModel;
      if (m.dataset.variant && variantInput) variantInput.value = m.dataset.variant;
      closeModels();
      syncSticky();
    });
  });

  var qtyInput = wrap.querySelector('[data-qty-input]');
  function setQty(n){
    n = Math.max(1, Math.min(9, n));
    if (qtyInput) qtyInput.value = n;
    var unit = parseFloat((wrap.querySelector('.vyne-fpd-buy .price .now').textContent || '0').replace(/[^0-9.]/g,'')) || 0;
    var total = unit * n;
    var p = wrap.querySelector('[data-add-price]');
    if (p) p.textContent = '— $' + total;
    syncSticky();
  }
  var plus = wrap.querySelector('[data-qty-plus]');
  var minus = wrap.querySelector('[data-qty-minus]');
  if (plus)  plus.addEventListener('click', function(){ setQty(parseInt(qtyInput.value || '1', 10) + 1); });
  if (minus) minus.addEventListener('click', function(){ setQty(parseInt(qtyInput.value || '1', 10) - 1); });
  if (qtyInput) qtyInput.addEventListener('change', function(){ setQty(parseInt(qtyInput.value || '1', 10)); });

  var sticky = wrap.querySelector('[data-stickybar]');
  var stickySub = wrap.querySelector('[data-sticky-sub]');
  var stickyPrice = wrap.querySelector('[data-sticky-price]');
  function syncSticky(){
    if (stickySub) stickySub.textContent = (curModel ? curModel + ' · ' : '') + 'Qty ' + (qtyInput ? qtyInput.value : '1');
    var unit = parseFloat((wrap.querySelector('.vyne-fpd-buy .price .now').textContent || '0').replace(/[^0-9.]/g,'')) || 0;
    var n = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
    if (stickyPrice) stickyPrice.textContent = '$' + (unit * n);
  }
  var actions = wrap.querySelector('[data-actions]');
  if (actions && sticky && 'IntersectionObserver' in window) {
    var io2 = new IntersectionObserver(function(entries){
      var e = entries[0];
      sticky.classList.toggle('show', !e.isIntersecting && window.scrollY > 400);
    }, { rootMargin: '-80px 0px 0px 0px' });
    io2.observe(actions);
  }

  var stickyAdd = wrap.querySelector('[data-sticky-add]');
  if (stickyAdd) stickyAdd.addEventListener('click', function(){
    var form = wrap.querySelector('[data-add-form]');
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });

  var addBtn = wrap.querySelector('[data-add-btn]');
  if (addBtn) addBtn.addEventListener('click', function(){
    var orig = addBtn.innerHTML;
    setTimeout(function(){
      addBtn.innerHTML = '✓ Added to Bag';
      setTimeout(function(){ addBtn.innerHTML = orig; }, 1500);
    }, 50);
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    wrap.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    wrap.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  syncSticky();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyne-pdp-screen"]) return;
  try {
    
(function(){
  var wrap = document.querySelector('.vyne-spd-wrap');
  if (!wrap) return;

  function fmt(cents){ return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  /* ---- gallery ---- */
  var shots = [].slice.call(wrap.querySelectorAll('.vyne-spd-stage .vyne-spd-shot'));
  var thumbs = [].slice.call(wrap.querySelectorAll('.vyne-spd-thumbs .t'));
  var gi = 0;
  shots.forEach(function(s){ if (s.classList.contains('on')) gi = +s.dataset.i; });
  function showShot(i){
    gi = i;
    shots.forEach(function(s){ s.classList.toggle('on', +s.dataset.i === i); });
    thumbs.forEach(function(t){ t.classList.toggle('on', +t.dataset.i === i); });
    var t = thumbs[i], row = t && t.parentNode;
    if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: Math.max(0, t.offsetLeft - row.offsetLeft - 8), behavior: 'smooth' });
  }
  function shotFor(imageId){
    for (var k = 0; k < shots.length; k++) if (imageId && shots[k].dataset.image === imageId) return +shots[k].dataset.i;
    return -1;
  }

  /* ---- variants ---- */
  var variants = [];
  var vjson = wrap.querySelector('[data-variants]');
  if (vjson) { try { variants = JSON.parse(vjson.textContent); } catch(e){} }
  var modelBtns = [].slice.call(wrap.querySelectorAll('.vyne-spd-models.static [data-model]'));
  var colorBtns = [].slice.call(wrap.querySelectorAll('.vyne-spd-colors [data-color]'));
  var hasColor = colorBtns.length > 0;
  var cur = { model: '', color: '' };
  modelBtns.forEach(function(b){ if (b.classList.contains('on')) cur.model = b.dataset.model; });
  colorBtns.forEach(function(b){ if (b.classList.contains('on')) cur.color = b.dataset.color; });
  function variantFor(model, color){
    for (var i = 0; i < variants.length; i++){
      var v = variants[i];
      if (v.option1 === model && (!hasColor || v.option2 === color)) return v;
    }
    return null;
  }
  // A variant with no photo of its own shows any photo of the same model.
  function imageFor(v){
    if (v.featured_image) return String(v.featured_image.id);
    for (var i = 0; i < variants.length; i++) if (variants[i].option1 === v.option1 && variants[i].featured_image) return String(variants[i].featured_image.id);
    return '';
  }

  // With real variants each photo belongs to a model, so the gallery follows
  // the picker instead of rotating on its own.
  // The photos change only when the shopper taps a thumb or swipes (swipe: assets/vyne.js).
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ showShot(+t.dataset.i); }); });

  /* ---- buy panel ---- */
  var form = wrap.querySelector('[data-add-form]');
  var variantInput = wrap.querySelector('[data-variant-id]');
  var qtyInput = wrap.querySelector('[data-qty-input]');
  var priceNow = wrap.querySelector('[data-price-now]');
  var addBtn = wrap.querySelector('[data-add-btn]');
  var addLabel = wrap.querySelector('[data-add-label]');
  var addPrice = wrap.querySelector('[data-add-price]');
  var modelLabel = wrap.querySelector('[data-model-label]');
  var colorLabel = wrap.querySelector('[data-color-label]');
  var sticky = wrap.querySelector('[data-stickybar]');
  var stickySub = wrap.querySelector('[data-sticky-sub]');
  var stickyPrice = wrap.querySelector('[data-sticky-price]');
  var stickyAdd = wrap.querySelector('[data-sticky-add]');
  var stickyImg = wrap.querySelector('[data-sticky-img]');
  var unitCents = parseInt(form && form.getAttribute('data-price'), 10) || 0;
  var soldOut = !!(addBtn && addBtn.disabled);
  var curModel = modelBtns.length ? cur.model + (hasColor && cur.color ? ' · ' + cur.color : '') : '';

  function qty(){ return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1; }
  function syncTotals(){
    var n = qty();
    if (addPrice) addPrice.textContent = '— ' + fmt(unitCents * n);
    if (stickyPrice) stickyPrice.textContent = fmt(unitCents * n);
    if (stickySub) stickySub.textContent = (curModel ? curModel + ' · ' : '') + 'Qty ' + n;
  }
  function setSoldOut(out){
    soldOut = out;
    if (addBtn) addBtn.disabled = out;
    if (addLabel) addLabel.textContent = out ? 'Sold out' : 'Add to Cart';
    if (addPrice) addPrice.hidden = out;
    if (stickyAdd){ stickyAdd.disabled = out; stickyAdd.textContent = out ? 'Sold out' : 'Add to Cart'; }
  }

  function applyVariant(v){
    modelBtns.forEach(function(b){ var on = b.dataset.model === cur.model; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    colorBtns.forEach(function(b){ var on = b.dataset.color === cur.color; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    if (modelLabel) modelLabel.textContent = cur.model;
    if (colorLabel) colorLabel.textContent = cur.color;
    curModel = cur.model + (hasColor && cur.color ? ' · ' + cur.color : '');
    if (variantInput) variantInput.value = v.id;
    unitCents = v.price;
    if (priceNow) priceNow.textContent = fmt(unitCents);
    setSoldOut(!v.available);
    var i = shotFor(imageFor(v));
    if (i >= 0){
      showShot(i);
      var ti = thumbs[i] && thumbs[i].querySelector('img');
      if (stickyImg && ti) stickyImg.src = ti.src;
    }
    if (window.history && history.replaceState){
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u.toString());
    }
    syncTotals();
  }
  // Picking a model shows only the colours that model comes in, keeping the
  // current colour when the new model has it too.
  function pickModel(model){
    cur.model = model;
    if (hasColor){
      var keep = false, firstAvail = '', firstAny = '';
      colorBtns.forEach(function(b){
        var v = variantFor(model, b.dataset.color);
        b.hidden = !v;
        b.classList.toggle('out', !!v && !v.available);
        if (!v) return;
        if (!firstAny) firstAny = b.dataset.color;
        if (v.available && !firstAvail) firstAvail = b.dataset.color;
        if (b.dataset.color === cur.color) keep = true;
      });
      if (!keep) cur.color = firstAvail || firstAny;
    }
    var v = variantFor(cur.model, cur.color);
    if (v) applyVariant(v);
  }
  function pickColor(color){
    cur.color = color;
    var v = variantFor(cur.model, cur.color);
    if (v) applyVariant(v);
  }
  modelBtns.forEach(function(b){ b.addEventListener('click', function(){ pickModel(b.dataset.model); }); });
  colorBtns.forEach(function(b){ b.addEventListener('click', function(){ pickColor(b.dataset.color); }); });

  // Single-variant fallback: a fixed model list sent as a line-item property.
  var modelPick = wrap.querySelector('[data-modelpick]');
  if (modelPick){
    var modelTrigger = wrap.querySelector('[data-mp-trigger]');
    var modelName = wrap.querySelector('[data-model-name]');
    var modelSub = wrap.querySelector('[data-model-sub]');
    if (modelName) curModel = modelName.textContent.trim();
    var closeModels = function(){ modelPick.classList.remove('open'); if (modelTrigger) modelTrigger.setAttribute('aria-expanded', 'false'); };
    if (modelTrigger){
      modelTrigger.addEventListener('click', function(e){ e.stopPropagation(); var open = modelPick.classList.toggle('open'); modelTrigger.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.addEventListener('click', function(e){ if (!modelPick.contains(e.target)) closeModels(); });
    }
    modelPick.querySelectorAll('.vyne-spd-models .m').forEach(function(m){
      m.addEventListener('click', function(){
        modelPick.querySelectorAll('.vyne-spd-models .m').forEach(function(x){ x.classList.remove('on'); });
        m.classList.add('on');
        curModel = m.dataset.name || '';
        if (modelName) modelName.textContent = curModel;
        if (modelSub) modelSub.textContent = m.dataset.sub || '';
        var mp = wrap.querySelector('[data-model-prop]'); if (mp) mp.value = curModel;
        closeModels();
        syncTotals();
      });
    });
  }

  /* ---- quantity ---- */
  function setQty(n){
    if (qtyInput) qtyInput.value = Math.max(1, Math.min(9, n || 1));
    syncTotals();
  }
  var plus = wrap.querySelector('[data-qty-plus]');
  var minus = wrap.querySelector('[data-qty-minus]');
  if (plus)  plus.addEventListener('click', function(){ setQty(qty() + 1); });
  if (minus) minus.addEventListener('click', function(){ setQty(qty() - 1); });
  if (qtyInput) qtyInput.addEventListener('change', function(){ setQty(parseInt(qtyInput.value, 10)); });

  /* ---- sticky bar ---- */
  var actions = wrap.querySelector('[data-actions]');
  if (actions && sticky && 'IntersectionObserver' in window) {
    var io2 = new IntersectionObserver(function(entries){
      var e = entries[0];
      sticky.classList.toggle('show', !e.isIntersecting && window.scrollY > 400);
    }, { rootMargin: '-80px 0px 0px 0px' });
    io2.observe(actions);
  }
  if (stickyAdd) stickyAdd.addEventListener('click', function(){
    if (soldOut || !form) return;
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  });

  if (addBtn) addBtn.addEventListener('click', function(){
    if (soldOut) return;
    setTimeout(function(){
      if (addLabel) addLabel.textContent = '✓ Added to Bag';
      if (addPrice) addPrice.hidden = true;
      setTimeout(function(){ setSoldOut(soldOut); }, 1500);
    }, 50);
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    wrap.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    wrap.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  syncTotals();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyne-pdp-white"]) return;
  try {
    
(function(){
  var wrap = document.querySelector('.vyne-wpd-wrap');
  if (!wrap) return;

  var shots = wrap.querySelectorAll('.vyne-wpd-stage .vyne-wpd-shot');
  var thumbs = wrap.querySelectorAll('.vyne-wpd-thumbs .t');
  function showShot(i){
    shots.forEach(function(s){ s.classList.toggle('on', +s.dataset.i === i); });
    thumbs.forEach(function(t){ t.classList.toggle('on', +t.dataset.i === i); });
  }
  // The photos change only when the shopper taps a thumb or swipes (swipe: assets/vyne.js).
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ showShot(+t.dataset.i); }); });

  var modelName = wrap.querySelector('[data-model-name]');
  var modelSub = wrap.querySelector('[data-model-sub]');
  var variantInput = wrap.querySelector('[data-variant-id]');
  var modelPick = wrap.querySelector('[data-modelpick]');
  var modelTrigger = wrap.querySelector('[data-mp-trigger]');
  var curModel = modelName ? modelName.textContent.trim() : '';
  function closeModels(){ if (modelPick) modelPick.classList.remove('open'); if (modelTrigger) modelTrigger.setAttribute('aria-expanded', 'false'); }
  if (modelTrigger && modelPick) {
    modelTrigger.addEventListener('click', function(e){ e.stopPropagation(); var open = modelPick.classList.toggle('open'); modelTrigger.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.addEventListener('click', function(e){ if (!modelPick.contains(e.target)) closeModels(); });
  }
  wrap.querySelectorAll('.vyne-wpd-models .m').forEach(function(m){
    m.addEventListener('click', function(){
      wrap.querySelectorAll('.vyne-wpd-models .m').forEach(function(x){ x.classList.remove('on'); });
      m.classList.add('on');
      curModel = m.dataset.name || '';
      if (modelName) modelName.textContent = curModel;
      if (modelSub) modelSub.textContent = m.dataset.sub || '';
      var mp = wrap.querySelector('[data-model-prop]'); if (mp) mp.value = curModel;
      if (m.dataset.variant && variantInput) variantInput.value = m.dataset.variant;
      closeModels();
      syncSticky();
    });
  });

  var qtyInput = wrap.querySelector('[data-qty-input]');
  function setQty(n){
    n = Math.max(1, Math.min(9, n));
    if (qtyInput) qtyInput.value = n;
    var unit = parseFloat((wrap.querySelector('.vyne-wpd-buy .price .now').textContent || '0').replace(/[^0-9.]/g,'')) || 0;
    var total = unit * n;
    var p = wrap.querySelector('[data-add-price]');
    if (p) p.textContent = '— $' + total;
    syncSticky();
  }
  var plus = wrap.querySelector('[data-qty-plus]');
  var minus = wrap.querySelector('[data-qty-minus]');
  if (plus)  plus.addEventListener('click', function(){ setQty(parseInt(qtyInput.value || '1', 10) + 1); });
  if (minus) minus.addEventListener('click', function(){ setQty(parseInt(qtyInput.value || '1', 10) - 1); });
  if (qtyInput) qtyInput.addEventListener('change', function(){ setQty(parseInt(qtyInput.value || '1', 10)); });

  var sticky = wrap.querySelector('[data-stickybar]');
  var stickySub = wrap.querySelector('[data-sticky-sub]');
  var stickyPrice = wrap.querySelector('[data-sticky-price]');
  function syncSticky(){
    if (stickySub) stickySub.textContent = (curModel ? curModel + ' · ' : '') + 'Qty ' + (qtyInput ? qtyInput.value : '1');
    var unit = parseFloat((wrap.querySelector('.vyne-wpd-buy .price .now').textContent || '0').replace(/[^0-9.]/g,'')) || 0;
    var n = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
    if (stickyPrice) stickyPrice.textContent = '$' + (unit * n);
  }
  var actions = wrap.querySelector('[data-actions]');
  if (actions && sticky && 'IntersectionObserver' in window) {
    var io2 = new IntersectionObserver(function(entries){
      var e = entries[0];
      sticky.classList.toggle('show', !e.isIntersecting && window.scrollY > 400);
    }, { rootMargin: '-80px 0px 0px 0px' });
    io2.observe(actions);
  }

  var stickyAdd = wrap.querySelector('[data-sticky-add]');
  if (stickyAdd) stickyAdd.addEventListener('click', function(){
    var form = wrap.querySelector('[data-add-form]');
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });

  var addBtn = wrap.querySelector('[data-add-btn]');
  if (addBtn) addBtn.addEventListener('click', function(){
    var orig = addBtn.innerHTML;
    setTimeout(function(){
      addBtn.innerHTML = '✓ Added to Bag';
      setTimeout(function(){ addBtn.innerHTML = orig; }, 1500);
    }, 50);
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    wrap.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    wrap.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  syncSticky();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyne-pdp"]) return;
  try {
    
(function(){
  var wrap = document.querySelector('.vyne-pdp-wrap');
  if (!wrap) return;

  /* GALLERY */
  var shots = wrap.querySelectorAll('.vyne-pdp-stage .vyne-pdp-shot');
  var thumbs = wrap.querySelectorAll('.vyne-pdp-thumbs .t');
  function showShot(i){
    shots.forEach(function(s){ s.classList.toggle('on', +s.dataset.i === i); });
    thumbs.forEach(function(t){ t.classList.toggle('on', +t.dataset.i === i); });
  }
  // The photos change only when the shopper taps a thumb or swipes (swipe: assets/vyne.js).
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ showShot(+t.dataset.i); }); });

  /* MODELS (collapsible dropdown) */
  var modelName = wrap.querySelector('[data-model-name]');
  var modelSub = wrap.querySelector('[data-model-sub]');
  var variantInput = wrap.querySelector('[data-variant-id]');
  var modelPick = wrap.querySelector('[data-modelpick]');
  var modelTrigger = wrap.querySelector('[data-mp-trigger]');
  var curModel = modelName ? modelName.textContent.trim() : '';
  function closeModels(){ if (modelPick) modelPick.classList.remove('open'); if (modelTrigger) modelTrigger.setAttribute('aria-expanded', 'false'); }
  if (modelTrigger && modelPick) {
    modelTrigger.addEventListener('click', function(e){ e.stopPropagation(); var open = modelPick.classList.toggle('open'); modelTrigger.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.addEventListener('click', function(e){ if (!modelPick.contains(e.target)) closeModels(); });
  }
  wrap.querySelectorAll('.vyne-pdp-models .m').forEach(function(m){
    m.addEventListener('click', function(){
      wrap.querySelectorAll('.vyne-pdp-models .m').forEach(function(x){ x.classList.remove('on'); });
      m.classList.add('on');
      curModel = m.dataset.name || '';
      if (modelName) modelName.textContent = curModel;
      if (modelSub) modelSub.textContent = m.dataset.sub || '';
      var mp = wrap.querySelector('[data-model-prop]'); if (mp) mp.value = curModel;
      if (m.dataset.variant && variantInput) variantInput.value = m.dataset.variant;
      closeModels();
      syncSticky();
    });
  });

  /* QTY */
  var qtyInput = wrap.querySelector('[data-qty-input]');
  function setQty(n){
    n = Math.max(1, Math.min(9, n));
    if (qtyInput) qtyInput.value = n;
    var unit = parseFloat((wrap.querySelector('.vyne-pdp-buy .price .now').textContent || '0').replace(/[^0-9.]/g,'')) || 0;
    var total = unit * n;
    var p = wrap.querySelector('[data-add-price]');
    if (p) p.textContent = '— $' + total;
    syncSticky();
  }
  var plus = wrap.querySelector('[data-qty-plus]');
  var minus = wrap.querySelector('[data-qty-minus]');
  if (plus)  plus.addEventListener('click', function(){ setQty(parseInt(qtyInput.value || '1', 10) + 1); });
  if (minus) minus.addEventListener('click', function(){ setQty(parseInt(qtyInput.value || '1', 10) - 1); });
  if (qtyInput) qtyInput.addEventListener('change', function(){ setQty(parseInt(qtyInput.value || '1', 10)); });

  /* STICKY */
  var sticky = wrap.querySelector('[data-stickybar]');
  var stickySub = wrap.querySelector('[data-sticky-sub]');
  var stickyPrice = wrap.querySelector('[data-sticky-price]');
  function syncSticky(){
    if (stickySub) stickySub.textContent = (curModel ? curModel + ' · ' : '') + 'Qty ' + (qtyInput ? qtyInput.value : '1');
    var unit = parseFloat((wrap.querySelector('.vyne-pdp-buy .price .now').textContent || '0').replace(/[^0-9.]/g,'')) || 0;
    var n = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
    if (stickyPrice) stickyPrice.textContent = '$' + (unit * n);
  }
  var actions = wrap.querySelector('[data-actions]');
  if (actions && sticky && 'IntersectionObserver' in window) {
    var io2 = new IntersectionObserver(function(entries){
      var e = entries[0];
      sticky.classList.toggle('show', !e.isIntersecting && window.scrollY > 400);
    }, { rootMargin: '-80px 0px 0px 0px' });
    io2.observe(actions);
  }

  /* Sticky add forwards to the main form submit */
  var stickyAdd = wrap.querySelector('[data-sticky-add]');
  if (stickyAdd) stickyAdd.addEventListener('click', function(){
    var form = wrap.querySelector('[data-add-form]');
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });

  /* Add-to-bag visual feedback */
  var addBtn = wrap.querySelector('[data-add-btn]');
  if (addBtn) addBtn.addEventListener('click', function(){
    var orig = addBtn.innerHTML;
    setTimeout(function(){
      addBtn.innerHTML = '✓ Added to Bag';
      setTimeout(function(){ addBtn.innerHTML = orig; }, 1500);
    }, 50);
  });

  /* Reveal */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    wrap.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    wrap.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  syncSticky();
})();

  } catch(e) { console.error(e); }
})();
})();
